// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button";

// sections for this page
import ForumsMeetApprenticesPanel from "../ForumsMeetApprenticesPanel/ForumsMeetApprenticesPanel";
import ForumsTopicAddPostWrapper from "../ForumsTopicAddPost/ForumsTopicAddPost";
import ForumsBlockerModal from "../ForumsBlockerModal/ForumsBlockerModal";
import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle";

// local assets
import { useForumContext } from "../../contexts/forum";
import { updateQueryString } from "../../util/url";
import { useRouter } from "next/router";
import { useAuthContext } from "../../contexts/auth";
import { useState } from "react";


const useStyles = makeStyles()(styles);

export default function EmployerForumPanel(props) {
    const router = useRouter();
    const { auth } = useAuthContext();
    const { classes, cx } = useStyles();
    const data = props.data;

    const { forums } = useForumContext();

    const apprentices = forums?.category?.guestPosters.filter(apprentice => apprentice.active === true);

    const [textEditorOpen, setTextEditorOpen] = useState(false);
    const [blockerOpen, setBlockerOpen] = useState(false);

    const openTextEditor = async () => {
        if (auth.user == null) {
            await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
        } else {
            if (forums.isAtPostLimit) {
                setBlockerOpen(true);
            } else {
                setTextEditorOpen(true);
            }
        }
    };

    const closeTextEditor = () => {
        setTextEditorOpen(false);
    };


    return (
        <div className={classes.forumSidePanel}>
            <div className={classes.forumSidePanelBox}>
                <h1 className={classes.forumSidePanelTitle}>Ask {props.employerName} a question</h1>
                <Button className={cx(classes.darkButton + " " + classes.signUpButton)} onClick={(e) => openTextEditor(e)}>Ask a question</Button>
                <ForumsTopicAddPostWrapper topic={null} open={textEditorOpen} onClose={closeTextEditor} community={data?.category?.name}>
                </ForumsTopicAddPostWrapper>
                {blockerOpen && (
                    <ForumsBlockerModal
                        type={"timeout"}
                        open={blockerOpen}
                        onClose={() => setBlockerOpen(false)}
                    />
                )}
            </div>
            {apprentices?.length > 0 && (
                <div className={cx(classes.forumSidePanelBox)}>
                    <ForumsMeetApprenticesPanel data={data} apprentices={apprentices} employerId={props.employerId} employerName={props.employerName} />
                </div>
            )}
        </div>
    )
}

